import { Fragment, useEffect } from "react";

import przeszlosc_1_1 from "assets/img/archive/1/przeszlosc_1_1.jpg";
import przeszlosc_1_2 from "assets/img/archive/1/przeszlosc_1_2.jpg";
import PrimaryButton from "Components/PrimaryButton";
import { useMemo, useState } from "react";
import { animated, useTransition } from "react-spring";
import { useTranslation } from "react-i18next";

const ArchiveFirst = ({
  setPageTitle,
  setShowMenuToggler,
  setIsBackgroundMusic,
  setReturnLink,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    setPageTitle(t("archive"));
    setShowMenuToggler(true);
    setIsBackgroundMusic(true);
    setReturnLink({ link: "/scene", from: "archive" });
  }, [setPageTitle, setShowMenuToggler, setReturnLink, setIsBackgroundMusic]);

  const images = useMemo(() => [przeszlosc_1_1, przeszlosc_1_2], []);
  const [activeImage, setActiveImage] = useState(images[0]);
  const [isReverse, setIsReverse] = useState(false);
  const reverseHandler = () => {
    setIsReverse(!isReverse);
  };
  useEffect(() => {
    setActiveImage(isReverse ? images[1] : images[0]);
  }, [isReverse, setActiveImage, images]);

  const transitions = useTransition(activeImage, {
    key: isReverse.active,
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 500 },
    exitBeforeEnter: false,
  });
  return (
    <Fragment>
      <div className="container-fluid px-4 mt-5 pt-5">
        <div className="row gx-5">
          <div className="col-md-8 pt-1 mt-1">
            <div className="ps-3 pe-2 me-1 position-relative min-vh-75">
              {transitions((props, item) => {
                return (
                  <animated.div style={props}>
                    <img
                      src={item}
                      alt="archive"
                      className="w-100 position-absolute user-drag-none"
                    />
                  </animated.div>
                );
              })}
            </div>
          </div>
          <div className="col-md-4 d-flex flex-column">
            <h2 className="text-uppercase">
              {t("journey to the church fair in sulisławice")}
            </h2>
            <div className="row gx-4 mt-4 pt-3 pb-1">
              <div className="col-6">
                <span className="fs-14">MIKOŁAJÓW | 1956</span>
              </div>
              <div className="col-6 opacity-50">
                <span className="fs-14">
                  {t("Photo: Archive of Mrs. Henryka Thomas")}
                </span>
              </div>
            </div>
            <div className="w-100 my-2 white-line" />
            <div className="row gx-4 pt-1">
              <div className="col-6">
                <div className="">
                  <span className="d-block fs-18 ">
                    {t("ArchiveFirstContentLeft")}
                  </span>
                </div>
              </div>
              <div className="col-6">
                <div className="">
                  <span className="d-block fs-18">
                    {t("ArchiveFirstContentRight")}

                    <p className="mt-4">
                      <i>Henryka Tomtas</i>
                    </p>
                  </span>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <PrimaryButton
                className={`primary mb-4 ${
                  !isReverse ? "" : "btn-active"
                }`}
                text={t("Turn the Photo Over")}
                isArrow={false}
                onClick={reverseHandler}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ArchiveFirst;
